export function offlineBookingForm() {
  // variables
  const travellersNumber = document.querySelector('[data-travellers-number]');
  const travellerSections = document.querySelectorAll(
    '[data-traveller-section]'
  );
  const travellerRequireds = document.querySelectorAll(
    '[data-traveller-required]'
  );
  const sectionContainers = document.querySelectorAll(
    '[data-section-container]'
  );
  const checkBoxes = document.querySelectorAll('[data-checkbox-trigger]');

  // simple functions
  function uncheckCheckboxes() {
    if (checkBoxes.length) {
      Array.from(checkBoxes).forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
  }
  function resetTravellersNumberValue() {
    if (travellersNumber != null) {
      travellersNumber.value = '1';
    }
  }
  function removeRequireds(requireds, addsectionHidden) {
    if (requireds.length) {
      Array.from(requireds).forEach((required) => {
        required.removeAttribute('required');
        required.removeAttribute('aria-required');
        if (addsectionHidden === 'addsectionHidden') {
          required.setAttribute('data-traveller-required', 'section-hidden');
        }
      });
    }
  }
  function addRequireds(requireds, removesectionHidden) {
    if (requireds.length) {
      Array.from(requireds).forEach((required) => {
        if (
          required.getAttribute('data-traveller-required') !== 'section-hidden'
        ) {
          required.setAttribute('required', 'required');
          required.setAttribute('aria-required', 'true');
        }

        if (
          required.getAttribute('data-traveller-required') === 'section-hidden'
        ) {
          if (removesectionHidden === 'removesectionHidden') {
            required.setAttribute('data-traveller-required', '');
            required.setAttribute('required', 'required');
            required.setAttribute('aria-required', 'true');
          }
        }
      });
    }
  }

  // compound functions
  function hideAllSectionsButFirst() {
    if (travellerSections.length && travellerRequireds.length) {
      // hide all sections
      Array.from(travellerSections).forEach((section) => {
        section.classList.add('u-display-none');
      });
      // show first section
      travellerSections[0].classList.remove('u-display-none');

      // create subset of requireds for first section
      const travellerRequiredsFirst = travellerSections[0].querySelectorAll(
        '[data-traveller-required]'
      );
      // hide all requireds
      removeRequireds(travellerRequireds);
      // show first section requireds
      addRequireds(travellerRequiredsFirst);
    }
  }

  // main function which executes immediately
  function mainFunction() {
    // reset functions
    resetTravellersNumberValue();
    uncheckCheckboxes();
    hideAllSectionsButFirst();

    // hide sections when travellers number changes
    if (travellersNumber != null) {
      travellersNumber.addEventListener('change', (e) => {
        if (travellerSections && travellerRequireds) {
          const selectedNumber = travellersNumber.value;

          Array.from(travellerSections).forEach((section) => {
            // section variables
            const sectionNumber = section.getAttribute(
              'data-traveller-section'
            );
            const requireds = section.querySelectorAll(
              '[data-traveller-required]'
            );

            if (sectionNumber != null && requireds.length) {
              // reset all sections to be visible
              section.classList.remove('u-display-none');
              // reset all section requireds to be required
              addRequireds(requireds);
              // reset all section requireds to be visible
              section.classList.remove('u-display-none');

              if (parseInt(sectionNumber) > parseInt(selectedNumber)) {
                // hide selected section
                section.classList.add('u-display-none');
                // remove all section requires
                removeRequireds(requireds);
              }
            }
          });
        }
      });
    }

    // trigger behaviour for checkboxes
    if (sectionContainers.length) {
      Array.from(sectionContainers).forEach((container) => {
        // container variables
        const triggers = container.querySelectorAll('[data-checkbox-trigger]');
        const target = container.querySelector('[data-checkbox-target]');
        const requireds = container.querySelectorAll(
          '[data-traveller-required]'
        );

        // single checkboxes
        if (triggers.length) {
          if (triggers.length === 1) {
            Array.from(triggers).forEach((trigger) => {
              trigger.addEventListener('change', (e) => {
                if (trigger.checked === true) {
                  // hide selected target
                  target.classList.add('u-display-none');
                  removeRequireds(requireds, 'addsectionHidden');
                } else {
                  // show selected target
                  target.classList.remove('u-display-none');
                  addRequireds(requireds, 'removesectionHidden');
                }
              });
            });
          }
        }

        // double checkboxes
        if (triggers.length) {
          if (triggers.length === 2) {
            Array.from(triggers).forEach((trigger) => {
              trigger.addEventListener('change', (e) => {
                const currentTrigger = trigger;

                // show and hide target if either checkbox is checked
                if (
                  triggers[0].checked === true ||
                  triggers[1].checked === true
                ) {
                  // hide selected target
                  target.classList.add('u-display-none');
                  removeRequireds(requireds, 'addsectionHidden');
                } else {
                  // show selected target
                  target.classList.remove('u-display-none');
                  addRequireds(requireds, 'removesectionHidden');
                }

                // hide other checkbox when one checkbox is checked
                for (let i = 0; i < triggers.length; i += 1) {
                  if (currentTrigger.checked === true) {
                    for (let i = 0; i < triggers.length; i += 1) {
                      if (triggers[i].parentElement.tagName === 'LABEL') {
                        triggers[i].parentElement.classList.add(
                          'u-display-none'
                        );
                      }
                      if (currentTrigger.parentElement.tagName === 'LABEL') {
                        currentTrigger.parentElement.classList.remove(
                          'u-display-none'
                        );
                      }
                    }
                  } else if (currentTrigger.checked === false) {
                    for (let i = 0; i < triggers.length; i += 1) {
                      if (triggers[i].parentElement.tagName === 'LABEL') {
                        triggers[i].parentElement.classList.remove(
                          'u-display-none'
                        );
                      }
                    }
                  }
                }
              });
            });
          }
        }
      });
    }
  }
  mainFunction();
}

export default { offlineBookingForm };
